export default __webpack_public_path__ + "static/media/plus-button.d060ac1d.svg";